define("shared/components/shared/media/filter/filter-profile", ["exports", "@ember/component", "@ember/service", "@ember/utils", "@glimmer/component", "@glimmer/tracking", "@ember/template-factory"], function (_exports, _component, _service, _utils, _component2, _tracking, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"@glimmer/tracking",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--formWrapper qa--mediaLib_profile_drpdwn">
    <PowerSelect
      @onChange={{action @toggleSocialProfile}}
      @options={{this.socialProfileOptions}}
      @renderInPlace={{true}}
      @searchEnabled={{false}}
      @selected={{this.selectedProfile}}
      data-test-id="filter-profile-select"
      as |profile|
    >
      <span class="qa--mediaLib_profileSelect" {{did-update this.buildSocialProfileOptions}} {{perfect-scroll}}>
        <i class="{{profile.profileIconColorClass}} u--m__r__xs"></i>
        <span data-test-id="social-profile-option">
          {{profile.displayNickname}}
        </span>
      </span>
    </PowerSelect>
  </div>
  */
  {
    "id": "MsP0d8JA",
    "block": "[[[10,0],[14,0,\"o--formWrapper qa--mediaLib_profile_drpdwn\"],[12],[1,\"\\n  \"],[8,[39,0],[[24,\"data-test-id\",\"filter-profile-select\"]],[[\"@onChange\",\"@options\",\"@renderInPlace\",\"@searchEnabled\",\"@selected\"],[[28,[37,1],[[30,0],[30,1]],null],[30,0,[\"socialProfileOptions\"]],true,false,[30,0,[\"selectedProfile\"]]]],[[\"default\"],[[[[1,\"\\n    \"],[11,1],[24,0,\"qa--mediaLib_profileSelect\"],[4,[38,2],[[30,0,[\"buildSocialProfileOptions\"]]],null],[4,[38,3],null,null],[12],[1,\"\\n      \"],[10,\"i\"],[15,0,[29,[[30,2,[\"profileIconColorClass\"]],\" u--m__r__xs\"]]],[12],[13],[1,\"\\n      \"],[10,1],[14,\"data-test-id\",\"social-profile-option\"],[12],[1,\"\\n        \"],[1,[30,2,[\"displayNickname\"]]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[2]]]]],[1,\"\\n\"],[13]],[\"@toggleSocialProfile\",\"profile\"],false,[\"power-select\",\"action\",\"did-update\",\"perfect-scroll\"]]",
    "moduleName": "shared/components/shared/media/filter/filter-profile.hbs",
    "isStrictMode": false
  });
  let FilterProfileComponent = _exports.default = (_class = class FilterProfileComponent extends _component2.default {
    get allSelected() {
      return (0, _utils.isEmpty)(this.args.selectedSocialProfileIds) || this.args.selectedSocialProfileIds[0] == null;
    }
    get selectedProfile() {
      if (this.allSelected) {
        return this.socialProfileOptions[0];
      }
      return this.socialProfileOptions.find(socialProfile => socialProfile.id === String(this.args.selectedSocialProfileIds[0]));
    }
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "intl", _descriptor, this);
      _initializerDefineProperty(this, "socialProfileOptions", _descriptor2, this);
      this.buildSocialProfileOptions();
    }
    buildSocialProfileOptions() {
      this.socialProfileOptions = [{
        id: null,
        profileIconColorClass: '',
        displayNickname: this.intl.t('media_library.filter.all_profiles')
      }, ...this.args.group.socialProfiles.map(socialProfile => ({
        id: socialProfile.get('id'),
        profileIconColorClass: socialProfile.get('profileIconColorClass'),
        displayNickname: socialProfile.get('displayNickname')
      }))];
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "socialProfileOptions", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, FilterProfileComponent);
});